module.exports = __webpack_public_path__ + "./img/ArticulosInicio.5fc44ad35f406d28b68b73250a1d6eff.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/ArticulosInicio.png
// module id = ./public/img/Help/ArticulosInicio.png
// module chunks = 0